// extracted by mini-css-extract-plugin
export default {"expressCheckoutSection":"vE-z","expressButtonContainerWithPayPal":"wE-z","expressButton":"xE-z","or":"yE-z"};